import { getFeatureParam } from 'Cloud/Application/FeaturesEs6';

/**
 * В Safari возникает ошибка при попытке прочитать файл более 2GB.
 * Firefox выбрасывает исключение NS_ERROR_OUT_OF_MEMORY,
 * когда размер файла превышает объем свободной памяти.
 * В Chrome может падать вкладка, когда не хватает памяти.
 * Поэтому будем пытаться читать файлы только небольшого размера.
 * @type {number}
 */
export const MAX_READABLE_SIZE = getFeatureParam('newUpload', 'maxReadableSize', 30) * 1024 * 1024;
